import { render, staticRenderFns } from "./ResendCode.vue?vue&type=template&id=1e397e75&scoped=true&"
import script from "./ResendCode.vue?vue&type=script&lang=js&"
export * from "./ResendCode.vue?vue&type=script&lang=js&"
import style0 from "./ResendCode.vue?vue&type=style&index=0&id=1e397e75&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e397e75",
  null
  
)

export default component.exports